@if (type == 1) {
  <div class="catalog-grid">
    @for (article of articlesH; track article.id) {
      @defer (on viewport) {
        @let city = cityLabel(article.city);
        @let date = dateLabel(article);
        <article class="catalog-card" appInViewport (enteredViewport)="ensureHistoricalThumbnail(article)"
          (click)="cardClick(article.id)" (keyup.enter)="cardClick(article.id)" tabindex="0">
          @if (article.ext == 'pdf') {
            <img [src]="thumbnailsH[article.src!] || 'assets/img/pdfCover.png'" [alt]="article.title" loading="lazy"
              decoding="async" oncontextmenu="return false;">
          } @else {
            <img [src]="urlServerLaraApiMultimedia + article.src" [alt]="article.title" loading="lazy" decoding="async"
              oncontextmenu="return false;">
          }
          <div class="catalog-card-copy">
            <div class="catalog-card-title">
              <h3>{{ article.title }}</h3>
            </div>
            <div class="catalog-card-meta">
              @if (article.category.title || article.subcategory) {
                <p>
                  {{ article.category.title }}
                  @if (article.subcategory) {
                    <span>({{ subcategoryLabel(article.subcategory) }})</span>
                  }
                </p>
              }
              @if (city || date) {
                <p>{{ city }}@if (city && date) { · }{{ date }}</p>
              }
            </div>
          </div>
        </article>
      } @placeholder {
        <div class="catalog-card catalog-card-pending" aria-hidden="true"></div>
      }
    }
  </div>
}

@if (type == 2) {
  <div class="catalog-grid">
    @for (article of articlesA; track article.id) {
      @defer (on viewport) {
        <article class="catalog-card" appInViewport (enteredViewport)="ensureArtisticThumbnail(article)"
          (click)="cardClick(article.id)" (keyup.enter)="cardClick(article.id)" tabindex="0">
          @if (article.ext == 'pdf') {
            <img [src]="thumbnailsA[article.src!] || 'assets/img/pdfCover.png'" [alt]="article.title" loading="lazy"
              decoding="async" oncontextmenu="return false;">
          } @else {
            <img [src]="urlServerLaraApiMultimedia + article.src" [alt]="article.title" loading="lazy" decoding="async"
              oncontextmenu="return false;">
          }
          <div class="catalog-card-copy">
            <div class="catalog-card-title">
              <h3>{{ article.title }}</h3>
            </div>
            <div class="catalog-card-meta">
              @if (article.pointofinterest || article.public_year) {
                <p>
                  {{ article.pointofinterest }}
                  @if (article.pointofinterest && article.public_year) { · }
                  {{ article.public_year }}
                </p>
              }
              @if (article.description) {
                <p>{{ article.description }}</p>
              }
            </div>
          </div>
        </article>
      } @placeholder {
        <div class="catalog-card catalog-card-pending" aria-hidden="true"></div>
      }
    }
  </div>
}